import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

export function Header(props: { onBack: () => void }) {
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
      <Typography variant="h4">История проверок доступов</Typography>
      <Button variant="outlined" onClick={props.onBack}>
        К списку сайтов
      </Button>
    </Box>
  );
}
